import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import './index.scss'

const Portfolio = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  useEffect(() => {
    const timer = setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)

    return () => clearTimeout(timer)
  }, [])

  return (
    <>
      <div className="container about-page">
        <div className="row">
          <div className="col s12 center-align">
            <h1 className={letterClass}>
              <AnimatedLetters
                letterClass={letterClass}
                strArray={['P', 'o', 'r', 't', 'f', 'o', 'l', 'i', 'o']}
                idx={15}
              />
            </h1>
          </div>
        </div>

        {/* Project Containers */}
        <div className="row project-container-wrapper">
          {/* Dreams IT */}
          <div className="col s12 m4 l4">
            <Link
              to="/Portfolio/DreamsIT"
              className="flat-button bubble-link-Dreams-IT"
            >
              Dreams IT Department | Service Desk Analyst | October 2023 -
              Present
            </Link>
          </div>

          {/* HighTech Plus - Trainee Project Manager */}
          <div className="col s12 m4 l4">
            <Link
              to="/Portfolio/TraineeProjectManager"
              className="bubble-link-Trainee-Project-Manager"
            >
              HighTech Plus | Trainee Project Manager | July 2023 - October 2023
            </Link>
          </div>

          {/* Dreams Retail */}
          <div className="col s12 m4 l4 dreams-retail">
            <Link
              to="/Portfolio/DreamsRetail"
              className="bubble-link-Dreams-Retail"
            >
              Dreams Retail Department | Customer Advisor | September 2021 -
              October 2023
            </Link>
          </div>
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default Portfolio
